import { FieldHtmlNameUtil } from '@onshape/www-inertia';
import UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import AbstractSignupScreen from './AbstractSignupScreen';
import type { UnifiedSignupScreenName } from '../UnifiedSignupScreenName';
import UnifiedSignupStartScreen from '../session-info/UnifiedSignupStartScreen';

export default class HomePageNameSignupScreen extends AbstractSignupScreen {
  public readonly screenName: UnifiedSignupScreenName = 'uss-signup-hp-name';

  public getVisibleComponents(): UnifiedSignupScreenComponent[] {
    return [
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.firstName),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.lastName),
      }),
    ];
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    this.getVisibleComponents().forEach((field) => {
      field.displayField.errorMessages = [];
    });
    return this.getVisibleComponents();
  }

  /** show this if start screen is homepage-signup and firstName is null */
  public predicate(): boolean {
    const { startScreen } = this.sessionInfo.value;
    const { firstName } = this.sessionInfo.value;
    return (
      UnifiedSignupStartScreen.homepageSignup.compareTo(startScreen) &&
      firstName === null &&
      this.isOkEmailOrPro()
    );
  }

  public async toNextScreen(): Promise<boolean> {
    const firstName = this.getField(FieldHtmlNameUtil.firstName).val;
    this.sessionInfo.value.firstName = firstName.toString();
    return true;
  }

  public getProgress(): number {
    return 10;
  }
}
